<template>
  <div
    :class="{
      block: block,
      'w-full': full,
    }"
  >
    <div class="flex">
      <Label
        :variant="InputLabelVariantCombination[variant].label"
        :size="size"
        v-if="label"
        >{{ label }}</Label
      >
      <span
        class="text-xs text-gray-400 p-1 flex flex-col justify-end"
        v-show="tag"
        >{{ tag }}</span
      >
    </div>

    <Input
      :modelValue="modelValue"
      :type="type"
      :placeholder="placeholder"
      :variant="InputLabelVariantCombination[variant].input"
      :size="size"
      :full="full"
      :readonly="readonly"
      :fontMono="fontMono"
      @update:modelValue="UpdateValue"
      @input="OnInput"
      @focus="OnFocus"
      @change="OnChange"
      @blur="OnBlur"
      @click="OnClick"
    />
    <p
      :class="
        (genericVariants?.[variant]?.classes, fontMono ? 'font-mono' : '')
      "
      class="text-xs m-0.5"
      v-show="message"
    >
      {{ message }}
    </p>
  </div>
</template>

<script setup lang="ts">
//Components
import Input from "@/components/atoms/BaseInput.vue";
import Label from "@/components/atoms/BaseLabel.vue";

// Types
import type { SizesKeysType } from "@/types/sizes.type";
import { SizesKeys } from "@/types/sizes.type";

//Component types & definitions
import { Types as InputTypes } from "../../atoms/Input";
import {
  VariantKeys as InputLabelVariantKeys,
  VariantsType as InputLabelVariantKeysType,
  variantCombination as InputLabelVariantCombination,
} from "@/components/molecules/inputLabel/InputLabel";
import { genericVariants } from "@/helpers/components/genericVariants.helper";

withDefaults(
  defineProps<{
    type?: keyof typeof InputTypes;
    modelValue?: string | number | Date;
    variant?: InputLabelVariantKeysType;
    size?: SizesKeysType;
    block?: boolean;
    full?: boolean;
    label?: string | undefined;
    tag?: string | undefined;
    message?: string | undefined;
    placeholder?: string | undefined;
    required?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    min?: number;
    max?: number;
    fontMono?: boolean;
  }>(),
  {
    type: InputTypes.text,
    modelValue: "",
    variant: InputLabelVariantKeys.primary,
    size: SizesKeys.default,
    block: false,
    full: true,
    label: undefined,
    tag: undefined,
    fontMono: false,
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "input", ev: Event): void;
  (e: "change", ev: Event): void;
  (e: "blur", ev: Event): void;
  (e: "focus", ev: Event): void;
  (e: "click", ev: Event): void;
}>();

const UpdateValue = (value: string) => {
  emit("update:modelValue", value);
};

const OnInput = (ev: Event) => {
  emit("input", ev);
};

const OnChange = (ev: Event) => {
  emit("change", ev);
};

const OnBlur = (ev: Event) => {
  emit("blur", ev);
};

const OnFocus = (ev: Event) => {
  emit("focus", ev);
};

const OnClick = (ev: Event) => {
  emit("click", ev);
};
</script>
